import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPersonalisationUsers = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 28,
	height: 23,
	viewBox: "0 0 28 23",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "inherit",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0.583008 19.3448C0.583008 16.144 3.17779 13.5492 6.37861 13.5492H11.9541C15.155 13.5492 17.7497 16.144 17.7497 19.3448C17.7497 21.2491 16.206 22.7928 14.3017 22.7928H4.03102C2.12674 22.7928 0.583008 21.2491 0.583008 19.3448ZM6.37861 15.7501C4.39329 15.7501 2.78387 17.3595 2.78387 19.3448C2.78387 20.0336 3.34224 20.592 4.03102 20.592H14.3017C14.9905 20.592 15.5489 20.0336 15.5489 19.3448C15.5489 17.3595 13.9394 15.7501 11.9541 15.7501H6.37861Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "inherit",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M19.5107 16.4104C19.5107 15.8026 20.0034 15.3099 20.6112 15.3099H22.812C25.3646 15.3099 27.4338 17.3792 27.4338 19.9317C27.4338 21.5119 26.1529 22.7929 24.5727 22.7929H20.6112C20.0034 22.7929 19.5107 22.3002 19.5107 21.6924C19.5107 21.0847 20.0034 20.592 20.6112 20.592H24.5727C24.9374 20.592 25.233 20.2964 25.233 19.9317C25.233 18.5947 24.1491 17.5108 22.812 17.5108H20.6112C20.0034 17.5108 19.5107 17.0181 19.5107 16.4104Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "inherit",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M9.16622 2.9851C7.34296 2.9851 5.86492 4.46314 5.86492 6.2864C5.86492 8.10965 7.34296 9.58769 9.16622 9.58769C10.9895 9.58769 12.4675 8.10965 12.4675 6.2864C12.4675 4.46314 10.9895 2.9851 9.16622 2.9851ZM3.66406 6.2864C3.66406 3.24764 6.12746 0.784241 9.16622 0.784241C12.205 0.784241 14.6684 3.24764 14.6684 6.2864C14.6684 9.32515 12.205 11.7886 9.16622 11.7886C6.12746 11.7886 3.66406 9.32515 3.66406 6.2864Z"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "inherit",
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M20.1712 7.82696C19.3203 7.82696 18.6305 8.51671 18.6305 9.36756C18.6305 10.2184 19.3203 10.9082 20.1712 10.9082C21.022 10.9082 21.7118 10.2184 21.7118 9.36756C21.7118 8.51671 21.022 7.82696 20.1712 7.82696ZM16.4297 9.36756C16.4297 7.30121 18.1048 5.6261 20.1712 5.6261C22.2375 5.6261 23.9126 7.30121 23.9126 9.36756C23.9126 11.4339 22.2375 13.109 20.1712 13.109C18.1048 13.109 16.4297 11.4339 16.4297 9.36756Z"
		})
	]
});
export default SvgPersonalisationUsers;
